import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Configuration from 'src/config/configuration';
import NetworkWithToken from "../../../config/networkwithtoken";
import { getConvertedParams } from 'src/config/helper';

export const courseCompleted = createAsyncThunk(
    "courseCompleted",
    async (params: {}) => {
      try {
        const response = await NetworkWithToken.post(
            getConvertedParams(Configuration.apis.courseCompleted, params)
        );
        if (response.status) {
          const resultData = response.data;
          return resultData;
        }
      } catch (err) {
        console.log(err);
      }
    },
  );


  interface completedCourse {
    data: [];
    error: string | null;
    message: string | null;
    status: boolean;
    statusCode: number;
  }
  
  interface completedCourseState {
    courseComplete: completedCourse;
    loading: boolean;
    error: any;
  }
  
  const courseCompletedApiResponse: completedCourse = {
    data: [],
    error: "",
    message: "",
    status: false,
    statusCode: 0,
  };
  
  const courseCompletedApiInitialState: completedCourseState = {
    courseComplete: courseCompletedApiResponse,
    loading: false,
    error: {},
  } satisfies completedCourseState as completedCourseState;

  const courseCompletedSlice = createSlice({
    name: "courseCompleted",
    initialState: courseCompletedApiInitialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(courseCompleted.pending, (state) => {
          state.loading = true;
          state.error = "";
          state.courseComplete = courseCompletedApiResponse
        })
        .addCase(courseCompleted.fulfilled, (state, action) => {
          state.loading = false;
          state.error = "";
          state.courseComplete = action.payload;
        })
        .addCase(courseCompleted.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.courseComplete = courseCompletedApiResponse;
        });
    },
  });

export default courseCompletedSlice.reducer;
